// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"b99870d1","16":"d6d1f158","44":"61175203","218":"4e0aefe4","349":"658269e1","361":"7d7d1a64","718":"a4dda55a","823":"98dbaa71"}[chunkId] + ".chunk.css";
};